import {
  CalciteDropdown,
  CalciteDropdownGroup,
  CalciteDropdownItem,
  CalciteNavigationUser,
} from "@esri/calcite-components-react";
import "@esri/calcite-components/dist/components/calcite-dropdown";
import "@esri/calcite-components/dist/components/calcite-dropdown-group";
import "@esri/calcite-components/dist/components/calcite-dropdown-item";
import "@esri/calcite-components/dist/components/calcite-navigation-user";
import { UserContext } from "context/UserContext";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "services/Auth";

export type UserMenuProps = {};

const UserMenu: React.FC<UserMenuProps> = () => {
  const authService = new AuthService();
  const { setIsLoggedIn, user, setUser, signout } = useContext(UserContext);
  const navigate = useNavigate();
  const [textDisabled, setTextDisabled] = useState<boolean | undefined>(false);
  useEffect(() => {
    if (!user) {
      setTextDisabled(true);
    }
  }, [user]);

  return (
    <CalciteDropdown
      style={{ paddingRight: 10 }}
      slot="user"
      overlayPositioning="fixed"
      placement="bottom-end"
    >
      <CalciteNavigationUser
        slot="trigger"
        fullName={`${user?.firstname} ${user?.lastname}`}
        username={user?.username}
        textDisabled={textDisabled}
      ></CalciteNavigationUser>

      <CalciteDropdownGroup selectionMode="none">
        <CalciteDropdownItem
          onCalciteDropdownItemSelect={() =>
            navigate("/profile", { replace: true })
          }
        >
          Profile
        </CalciteDropdownItem>
        <CalciteDropdownItem onCalciteDropdownItemSelect={signout}>
          Logout
        </CalciteDropdownItem>
      </CalciteDropdownGroup>
    </CalciteDropdown>
  );
};

export default UserMenu;
